import { Grid, Header, Icon } from 'semantic-ui-react'
import React, { Component } from 'react'
import Expandable from '../components/Expandable'

function Specialties() {
	const items = [
		{
			title: 'Realtime interaction',
			icon: 'heartbeat',
			iconColor: 'red',
			content: (
				<p>
					I build <strong>realtime</strong> web apps where users can see each other&#39;s
					changes immediately. For example, comments left by one user will show up to
					others without having to refresh the page.
				</p>
			)
		},
		{
			title: 'Rapid development',
			icon: 'lightning',
			iconColor: 'yellow',
			content: (
				<p>
					I use <strong>rapid</strong> web application development frameworks to get
					something useful in front of your users quickly for immediate feedback.
				</p>
			)
		},
		{
			title: 'Responsive Interfaces',
			icon: 'tablet',
			iconColor: 'blue',
			content: (
				<p>
					My interfaces are <strong>responsive</strong> to their environment and I build
					them just once to work everywhere from mobile phones to desktops.
				</p>
			)
		},
		{
			title: 'Robust solutions',
			icon: 'settings',
			iconColor: 'brown',
			content: (
				<p>
					I set <strong>robust</strong> foundations to support a large number of users
					while remaining extensible for future development and refinement.
				</p>
			)
		}
	]
	return (
		<div>
			<Header as="h3">
				<Header.Content>
					Some areas I focus on
					<Header.Subheader>
						I&#39;m happy to work in many areas and I love quickly building awesome web
						apps.
					</Header.Subheader>
				</Header.Content>
			</Header>
			<Grid columns="2" stackable className="padded-bottom">
				{items.map(item => (
					<Grid.Column key={item.title}>
						<Header as="h4">
							{/*
							<Icon name={item.icon} color={item.iconColor} />
							*/}
							<Header.Content>{item.title}</Header.Content>
						</Header>
						{item.content}
					</Grid.Column>
				))}
			</Grid>
		</div>
	)
}

export default class HowHelpSection extends Component {
	render() {
		function Building() {
			const items = [
				{
					title: 'Comprehensive web apps',
					icon: 'checkmark',
					iconColor: 'green',
					description: (
						<p>
							As an experienced full stack developer I can make your entire web
							application from start to finish with solid foundations.
						</p>
					)
				},
				{
					title: 'Minimum Viable Products',
					icon: 'send outline',
					iconColor: 'yellow',
					description: (
						<p>
							I can quickly create small apps from scratch to help test a product market
							fit.
						</p>
					)
				},
				{
					title: 'Additions',
					icon: 'plus',
					iconColor: 'blue',
					description: (
						<p>I&#39;m happy to add features to your existing web application.</p>
					)
				},
				{
					title: 'Maintenance',
					icon: 'checked calendar',
					iconColor: 'brown',
					description: (
						<p>
							Hire me for regular package and server updates, backups, etc so your
							application keeps running smoothly &amp; safely.
						</p>
					)
				},
				{
					title: 'Debugging',
					icon: 'bug',
					iconColor: 'grey',
					description: <p>Have me find and resolve bugs in your web application.</p>
				},
				{
					title: 'Rewrites',
					icon: 'refresh',
					iconColor: 'violet',
					description: (
						<p>
							If you have an old application I can recreate it with modern technology to
							improve stability, extensibility, and more.
						</p>
					)
				}
			]
			return (
				<Grid columns="3" stackable className="padded-bottom">
					{items.map(item => (
						<Grid.Column key={item.title}>
							<Header as="h3">
								<Icon name={item.icon} color={item.iconColor} />
								{item.title}
							</Header>
							{item.description}
						</Grid.Column>
					))}
				</Grid>
			)
		}

		function Functionality() {
			const items = [
				{
					title: 'Social APIs',
					content:
						'I can connect your app to Facebook, Twitter, etc. Whether you want your app to simply post there or run complex queries I can help.'
				},
				{
					title: 'Mapping',
					content: 'I can lookup addresses and display related information on a map.'
				},
				{
					title: 'Financial / E-commerce',
					content:
						'I can add credit card, ACH, and other financial functionality to your web app through APIs like Stripe.'
				},
				{
					title: 'Databases',
					content:
						'I can design for both relational databases (like MySQL) and NoSQL databases (like MongoDB) to store your data.'
				},
				{
					title: 'Performance & Scalability',
					content:
						'I can make your application work well under many conditions such as when there are lots of users, on low powered devices, and/or on slow internet connections.'
				},
				{
					title: 'Security',
					content:
						'I can add security features to your app from the simple CAPTCHA to complex fraud detection algorithms.'
				},
				{
					title: 'Algorithms',
					content:
						'If you have a complex problem, I can find existing solutions, or create new solutions.'
				}
			]
			return (
				<div>
					<Header as="h3">
						<Header.Content>
							A few things I can make work
							<Header.Subheader>
								There&#39;s so many possibilities; I&#39;ve listed a few here
							</Header.Subheader>
						</Header.Content>
					</Header>
					<Grid columns="2" stackable>
						{items.map(item => (
							<Grid.Column key={item.title}>
								<Header as="h4">{item.title}</Header>
								<p>{item.content}</p>
							</Grid.Column>
						))}
					</Grid>
				</div>
			)
		}

		function Analysis() {
			const items = [
				{
					title: 'Architecture',
					description:
						'There are innumerous technology choices when developing a web app. Though I lean towards what I know when developing, those choices are still wide. For example, if you have a lot of unstructured data coming from APIs you may be well served with a NoSQL database like MongoDB. If you have known structured data, a relational database such as MySQL can be a strength. Or maybe you need to get off the ground quickly and something like Firebase will suffice. A few other architecture choices that commonly have to be made include hosting, design frameworks, and language/transpilation choices.'
				},
				{
					title: 'Workflow',
					description:
						"I lean towards agile workflows in web app development because we often can't see the end at the start. However sometimes a clear picture is already in place and we can benefit from something more structured. I can help us decide and customize a work-flow that will best suit our collaboration to meet your needs."
				},
				{
					title: 'Code',
					description:
						'Whoever wrote it, I can look over code and provide feedback on how we might improve it. A few examples include adopting a style standard, adding unit tests, or re-architecting sub components.'
				}
			]

			return (
				<div>
					<Header as="h3">
						<Header.Content>
							Let me keep an eye on the big tech picture
							<Header.Subheader>To keep your project growing smoothly</Header.Subheader>
						</Header.Content>
					</Header>
					<Grid columns="1" stackable>
						{items.map(item => (
							<Grid.Column key={item.title}>
								<Header as="h4">{item.title}</Header>
								<p>{item.description}</p>
							</Grid.Column>
						))}
					</Grid>
				</div>
			)
		}

		return (
			<div>
				<Header as="h2">How I help</Header>
				<Building />

				<Header as="h3" textAlign="center">
					Hire me to give life to your amazing web app
				</Header>

				<Header as="h2">More help</Header>
				<Expandable buttonText="Specialties" startOpen={true}>
					<Specialties />
				</Expandable>
				<Expandable buttonText="Functionality">
					<Functionality />
				</Expandable>
				<Expandable buttonText="Analysis">
					<Analysis />
				</Expandable>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/HowHelpSection.js